/**
 * PostHog Analytics & Session Replay
 * All-in-one product analytics platform
 *
 * Phase B2: Analytics & Error Monitoring
 * https://posthog.com/docs/libraries/js
 */

(function() {
    'use strict';

    // Only initialize in production (not localhost or development environments)
    const isLocalhost = window.location.hostname === 'localhost' ||
        window.location.hostname.includes('127.0.0.1');

    if (isLocalhost) {
        return;
    }

    // Detect environment based on hostname
    const isDevelopment = window.location.hostname.includes('.myshopify.com');
    const environment = isDevelopment ? 'development' : 'production';

    // Load PostHog SDK
    ! function(t, e) {
        var o, n, p, r;
        e.__SV || (window.posthog = e, e._i = [], e.init = function(i, s, a) {
            function g(t, e) {
                var o = e.split(".");
                2 == o.length && (t = t[o[0]], e = o[1]), t[e] = function() {
                    t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
                }
            }(p = t.createElement("script")).type = "text/javascript", p.async = !0, p.src = s.api_host + "/static/array.js", (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
            var u = e;
            for (void 0 !== a ? u = e[a] = [] : a = "posthog", u.people = u.people || [], u.toString = function(t) {
                    var e = "posthog";
                    return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e
                }, u.people.toString = function() {
                    return u.toString(1) + ".people (stub)"
                }, o = "capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys onSessionId".split(" "), n = 0; n < o.length; n++) g(u, o[n]);
            e._i.push([i, s, a])
        }, e.__SV = 1)
    }(document, window.posthog || []);

    // Initialize PostHog
    posthog.init('phc_Tayt0MNUAfRmbFPQu5Ehg4sa73GAHY5mXEYNWtWAQqT', {
        api_host: 'https://us.i.posthog.com', // or 'https://eu.i.posthog.com' for EU

        // Environment
        loaded: function(posthog) {
            // Set environment as a super property (sent with all events)
            posthog.register({
                environment: environment,
                shopify_shop: window.Shopify?.shop || 'unknown',
                shopify_theme_id: window.Shopify?.theme?.id || 'unknown',
                shopify_currency: window.Shopify?.currency?.active || 'USD'
            });
        },

        // Session Replay Configuration
        session_recording: {
            enabled: true,
            recordCrossOriginIframes: false,
            maskAllInputs: true, // Mask all input fields for privacy
            maskTextSelector: '.private', // Mask elements with 'private' class
            recordCanvas: false, // Don't record canvas elements
            sample_rate: environment === 'production' ? 0.1 : 1.0, // 10% in prod, 100% in dev
            minimum_duration: 5000, // Only record sessions > 5 seconds
        },

        // Error Autocapture
        capture_pageview: true, // Auto-track page views
        capture_pageleave: true, // Track when users leave
        autocapture: true, // Auto-track clicks, form submissions

        // Privacy Settings
        respect_dnt: true, // Respect Do Not Track
        opt_out_capturing_by_default: false,

        // Performance
        xhr_headers: {}, // Don't send extra headers
        persistence: 'localStorage', // Use localStorage for persistence

        // Advanced Features
        enable_recording_console_log: true, // Capture console logs in session replay
        disable_session_recording: false,

        // Custom Properties
        property_blacklist: [ // Don't send these properties
            'password',
            'credit_card',
            'ssn',
            'cvv'
        ],

        // Toolbar (for admins to debug on live site)
        disable_toolbar: environment === 'production' // Enable in development only
    });

    // Identify user if logged in
    if (window.Shopify?.customerHash) {
        posthog.identify(window.Shopify.customerHash, {
            // User properties
            customer_id: window.Shopify.customerHash,
            // Don't send PII like email/name - just identifiers
        });
    }

    // Set up error tracking
    window.addEventListener('error', function(event) {
        posthog.capture('$exception', {
            $exception_type: event.error?.name || 'Error',
            $exception_message: event.error?.message || event.message,
            $exception_stack_trace: event.error?.stack,
            $exception_filename: event.filename,
            $exception_lineno: event.lineno,
            $exception_colno: event.colno,
            error_level: 'error'
        });
    });

    // Track unhandled promise rejections
    window.addEventListener('unhandledrejection', function(event) {
        posthog.capture('$exception', {
            $exception_type: 'UnhandledPromiseRejection',
            $exception_message: event.reason?.message || String(event.reason),
            $exception_stack_trace: event.reason?.stack,
            error_level: 'error'
        });
    });

    // Make PostHog globally available
    window.posthog = posthog;

})();